import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="navbar-wrapper">
      <Navbar expand="lg" className="custom-navbar" expanded={expanded} onToggle={setExpanded}>
        <Container fluid className="navbar-container">
          <Navbar.Brand as={Link} to="/" className="brand-logo" onClick={() => setExpanded(false)}>
            <img 
              src="/images/logo.jpeg" 
              alt="Manami Trading" 
              height="40" 
              className="logo-image" 
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto nav-links">
              <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>Home</Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={() => setExpanded(false)}>About Us</Nav.Link>
              <Nav.Link as={Link} to="/products" onClick={() => setExpanded(false)}>Products & Services</Nav.Link>
              <Nav.Link as={Link} to="/why-choose-us" onClick={() => setExpanded(false)}>Why Choose Us</Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={() => setExpanded(false)}>Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Navigation;